import React, { useState } from 'react';
import {
  Box, Button, FormControlLabel, Radio, RadioGroup, FormControl,
} from '@mui/material';
import ColorPicker from './ColorPicker';

type FontFamilies = {
  [key: string]: string;
};

interface ChangeLayoutSettingProps {
  main_color: string;
  text_color: string;
  background_color: string;
  text_font: string;
  onMainColorChange: (color: string) => void;
  onTextColorChange: (color: string) => void;
  onBackgroundColorChange: (color: string) => void;
  onFontChange: (font: string) => void;
}

export default function ChangeLayoutSetting({
  onMainColorChange,
  onTextColorChange,
  onBackgroundColorChange,
  onFontChange,
  main_color,
  text_color,
  background_color,
  text_font,
}: ChangeLayoutSettingProps) {
  const [mainColorHex, setMainColorHex] = useState(main_color ?? '#2664b1');
  const [textColorHex, setTextColorHex] = useState(text_color ?? '#333333');
  const [backgroundColorHex, setBackgroundColorHex] = useState(background_color ?? '#ffffff');
  const [selectedFont, setSelectedFont] = useState(text_font || '');

  const fontFamilies: FontFamilies = {
    default: '',
    'sans-serif': 'sans-serif',
    monospace: 'monospace',
    serif: 'serif',
  };

  const containerStyles = {
    backgroundColor: backgroundColorHex,
    color: textColorHex,
    fontFamily: selectedFont,
  };

  const handleMainColorChange = (color: string) => {
    setMainColorHex(color);
    onMainColorChange(color);
  };

  const handleTextColorChange = (color: string) => {
    setTextColorHex(color);
    onTextColorChange(color);
  };

  const handleBackgroundColorChange = (color: string) => {
    setBackgroundColorHex(color);
    onBackgroundColorChange(color);
  };

  const handleFontChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedKey = (event.target as HTMLInputElement).value;
    const fontFamilyValue = fontFamilies[selectedKey];
    setSelectedFont(fontFamilyValue);
    onFontChange(fontFamilyValue);
    console.log('fontFamilyValue', fontFamilyValue);
  };

  return (
    <Box>
      <h2 className="mb-3">カラー変更・フォント変更</h2>
      <p className="mb-1">ページの基本カラーおよびフォントの設定をします。</p>
      <hr className="mt-3" />
      <div className=" my-3">
        <label className="col-form-label text-bold mb-1">
          カラー設定
        </label>
        <div className="d-flex flex-column">
          <ColorPicker label="メイン" colorHex={mainColorHex} onColorChange={handleMainColorChange} />
          <ColorPicker label="文字色" colorHex={textColorHex} onColorChange={handleTextColorChange} />
          <ColorPicker
            label="背景色"
            colorHex={backgroundColorHex}
            onColorChange={handleBackgroundColorChange}
          />
        </div>
        <hr className="mt-3" />
        <div className="d-flex flex-column">
          <label className="col-form-label text-bold mb-1">フォント設定</label>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="font"
              defaultValue={selectedFont}
              onChange={handleFontChange}
            >
              <FormControlLabel
                value="helvetica"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="標準フォント"
              />
              <FormControlLabel
                value="sans-serif"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="ゴシック体系（Sans-Serif）"
              />
              <FormControlLabel
                value="monospace"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="ゴシック等幅系（monospace）"
              />
              <FormControlLabel
                value="serif"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="明朝体系（Serif）"
              />
            </RadioGroup>
          </FormControl>
        </div>
        <hr className="mt-3" />
        <div className="row">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-center">
              <div className="card w-100" style={containerStyles}>
                <div className="card-body py-3 text-center">
                  <h1 className="">HTMLサンプル</h1>
                </div>
                <div className="card-body py-0">
                  <p>
                    ここにテキストメッセージを表示します。ここにテキストメッセージを表示しますここにテキストメッセージを表示しますここにテキストメッセージを表示します
                  </p>
                </div>
                <div className="card-body py-3 text-center">
                  <Button
                    className="btn btn-primary"
                    variant="contained"
                    component="label"
                    size="small"
                    style={{
                      width: '80px',
                      backgroundColor: mainColorHex,
                      border: `2px solid ${mainColorHex}`,
                    }}
                  >
                    ボタン
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
